// extracted by mini-css-extract-plugin
module.exports = {"root":"GridContainer_root__29uD2","cell":"GridContainer_cell__1xMvz","title":"GridContainer_title__2OebF","allColumns":"GridContainer_allColumns__1a6fd"};